import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { MyObjectsListWidget } from 'widgets/kyrgyzstan/my-objects-list'
import { ObjectApplicationsWidget } from 'widgets/kyrgyzstan/object-applications'
import { ObjectBookingsWidget } from 'widgets/kyrgyzstan/object-bookings'

import { CreateObjectStepId } from 'entities/kyrgyzstan'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import { SupportContact } from './ui/support-contact'

import s from './styles.module.scss'

interface KyrgyzstanMyObjectsLocationState {
  orderRequestsCount?: number
}

const KyrgyzstanMyObjectsPage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const locationState =
    location.state as KyrgyzstanMyObjectsLocationState | null
  const orderRequestsCount = locationState?.orderRequestsCount

  const handleAddClick = () => {
    navigate(
      RoutingPaths.kyrgyzstan.objects.create.step.path(
        CreateObjectStepId.ObjectType,
      ),
    )
  }

  const handleObjectClick = (objectId: string) => {
    navigate(RoutingPaths.kyrgyzstan.objects.edit.path(objectId))
  }

  const handleRejectedObjectClick = (draftId: string) => {
    navigate(RoutingPaths.kyrgyzstan.objects.draftRevision.path(draftId))
  }

  const handleBookingsHistoryClick = () => {
    navigate(RoutingPaths.kyrgyzstan.objects.bookings.history.path())
  }

  const handleGoBack = () => {
    navigate(RoutingPaths.kyrgyzstan.path())
  }

  return (
    <main className={s.page}>
      <HeaderGoBack
        variant="grey"
        buttonWhite
        title={t('kyrgyzstan_block.my_objects.title')}
        onGoBack={handleGoBack}
      />

      <div className={clsx('container', s.content)}>
        <ObjectBookingsWidget onHistoryClick={handleBookingsHistoryClick} />

        <ObjectApplicationsWidget orderRequestsCount={orderRequestsCount} />

        <MyObjectsListWidget
          onAddClick={handleAddClick}
          onActiveObjectClick={handleObjectClick}
          onRejectedObjectClick={handleRejectedObjectClick}
        />

        <SupportContact />
      </div>
    </main>
  )
}

export default KyrgyzstanMyObjectsPage
